import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=8246625a&scoped=true&"
import script from "./TemplateTable.vue?vue&type=script&lang=js&"
export * from "./TemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTable.vue?vue&type=style&index=0&id=8246625a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8246625a",
  null
  
)

export default component.exports